export default __webpack_public_path__ + "static/logo-bge-871686ac24f8013894abc22ce88e3913.png";